module.exports = __webpack_public_path__ + "img/p1.152d4d98.png";